import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '@/sst/packages/functions/backend-trpc/src/routers';

export const trpc = createTRPCReact<AppRouter>();
